export default __webpack_public_path__ + "static/media/eniola.5bd157d1.webp";